module.exports = __webpack_public_path__ + "static/media/search_black.4cb99674.svg";